import { languages } from "@/config";
import useLocalStore from "@/hooks/useLocalStore";
import useTranslation from "@/hooks/useTranslation";
import { Avatar, Button, Dropdown, Flex, Typography } from "antd";
import PropTypes from "prop-types";
import { memo, useMemo } from "react";

const BUTTON_STYLE = {
    fontWeight: 600,
    fontSize: 16,
    color: "#808080",
    width: "100%",
    textAlign: "left",
    justifyContent: "left"
};

const LanguageSelect = ({showBtnLang=false}) => {
    const language = useLocalStore((s) => s.language) || "en";
    const setLanguage = useLocalStore((s) => s.setState);
    const current = languages?.find((f) => f.value === language);
    const { t } = useTranslation();

    const languageOptions = useMemo(() => languages?.map((lang) => ({
        key: lang?.value,
        label: (
            <Flex gap={4}>
                <Avatar src={lang?.img} alt={lang?.label} size={20} />
                <Typography.Text ellipsis={{ text: t(`lang.${lang?.value}`) }} style={{ width: "calc(100% - 28px)" }}>
                    {t(`lang.${lang?.value}`)}
                </Typography.Text>
            </Flex>
        ),
    })), [t]);

    const onLanguageChange = (key) => {
        setLanguage("language", key);
    };

    return (
        <Dropdown
            menu={{ items: languageOptions, onClick: ({ key }) => onLanguageChange(key), selectedKeys: language ? [language] : [] }}
            placement={showBtnLang ? "bottomRight" : "bottomLeft"}
            
        >
            <Flex gap={8} align="center">
                <Button
                    size="small"
                    shape="circle"
                    icon={<Avatar src={current?.img} alt={t(`lang.${current?.value}`)} size={24} style={{ cursor: "pointer" }} />}
                    style={{ padding: 0 }}
                    styles={{ icon: { padding: 0 } }}
                />
                <span style={BUTTON_STYLE}>
                    {showBtnLang && t(`lang.${current?.value}`)}
                </span>
            </Flex>
        </Dropdown>
    );
};

export default memo(LanguageSelect);

LanguageSelect.propTypes = {
    showBtnLang: PropTypes.bool,
};